import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';

const MicrosoftCallback: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const code = searchParams.get('code');
        const error = searchParams.get('error');
        const errorDescription = searchParams.get('error_description');

        if (error) {
          console.error('Microsoft OAuth error:', error, errorDescription);
          // Send error message to parent window
          if (window.opener) {
            window.opener.postMessage(
              {
                type: 'MICROSOFT_LOGIN_ERROR',
                error: errorDescription || error,
              },
              window.location.origin
            );
          }
          return;
        }

        if (code) {
          // Send success message to parent window
          if (window.opener) {
            window.opener.postMessage(
              {
                type: 'MICROSOFT_LOGIN_SUCCESS',
                code: code,
              },
              window.location.origin
            );
          }
        } else {
          // Send error message to parent window
          if (window.opener) {
            window.opener.postMessage(
              {
                type: 'MICROSOFT_LOGIN_ERROR',
                error: 'No authorization code received',
              },
              window.location.origin
            );
          }
        }
      } catch (error) {
        console.error('Error handling Microsoft callback:', error);
        // Send error message to parent window
        if (window.opener) {
          window.opener.postMessage(
            {
              type: 'MICROSOFT_LOGIN_ERROR',
              error: 'Failed to process callback',
            },
            window.location.origin
          );
        }
      }
    };

    handleCallback();
  }, [searchParams]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2,
      }}
    >
      <CircularProgress size={40} />
      <Typography variant="h6" color="text.secondary">
        Processing Microsoft login...
      </Typography>
      <Typography variant="body2" color="text.secondary">
        This window will close automatically
      </Typography>
    </Box>
  );
};

export default MicrosoftCallback;
